import React from 'react';
import SubjectPage from '../../Subjects/SubjectPage';

function Formula() {

    const pageTitleText = "JEE Formula Sheet ";

  return (
    <>
    
      <SubjectPage 
        name={pageTitleText} 
        link="formula" 
      />

    </>
  );
}

export default Formula;